<template>
  <div>
    <v-row>
      <v-card>
        <v-card-title class="text-h5">
          Pantalla de Cierre de Sesión
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-text-field
                    v-model="usuario.name"
                    label="Usuario Nombre Actual"
                    filled
                    disabled
                  ></v-text-field>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="cancelar">
            Cancelar
          </v-btn>
          <v-btn color="green darken-1" text @click="eliminarToken">
            Cerrar Sesión
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-row>
  </div>
</template>

 
<script>
import loginService from "@/services/loginService.js";

import router from "@/router/index";

export default {
  name: "Logout",
  // props:['enviarDependencia'],
  components: {},
  data: () => ({
    dialog: false,
    valid: true,
    token: "",
    messages: undefined,
    showPass: false,
    rules: {
      required: (value) => !!value || "Campo Requerido",
      min: (v) => v.length >= 5 || "Minimo 5 caracteres",
      emailMatch: () => `The email and password you entered don't match`,
    },

    usuarios: [],
    usuario: {
      id: "",
      name: "",
      pass: "",
      nombre: "",
      apellido: "",
      correo: "",
      celular: "",
      ci: "",
      dependencia: { id: "", descripcion: "" },
    },

    descripcionRules: [
      (v) => !!v || "Campo es requerido",
      (v) => (v && v.length >= 3) || "Debe contener al menos 3 caracteres",
    ],

    emailRules: [
      (v) => !!v || "Correo es requerido",
      (v) => /.+@.+\..+/.test(v) || "Correo debe ser valido",
    ],
  }),
  mounted() {},

  methods: {
    eliminarToken() {
      localStorage.removeItem("token");
      localStorage.removeItem("roles");
      this.$store.commit('vaciarCarrito');
      this.$store.commit('setRoles', []);
      this.$store.commit('setLogueado', false);
      alert("Cierre de Sesión exitoso");

      // window.location='/login';

      router.push("/login");
    },
    cancelar() {
      this.limpiar();
    },
    limpiar() {
      this.usuario = {
        id: "",
        name: "",
        pass: "",
        nombre: "",
        apellido: "",
        correo: "",
        celular: "",
        ci: "",
        dependencia: { id: "", descripcion: "" },
      };
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      //  this.$refs.form.reset();
      this.limpiar();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
  },
  computed: {},
};
</script>